import { addDays, isToday } from "date-fns";
import { EventBlock, HourLines, OffShade, TimeGutter, useDrop } from "@/components/calendar/Grid";
import { TOTAL_PX, dateKey, dayStatus, fmtRo, hm, layoutLanes, minutesAt, slotFromClick } from "@/lib/cal";
import { cn } from "@/lib/utils";

const DayColumn = ({ d, appts, staffById, selectedStaff, onSlot, onEvent, onMove }) => {
  const drop = useDrop(({ id, offsetMin }, e) => onMove(id, { start: `${dateKey(d)}T${hm(minutesAt(e, offsetMin))}` }));
  return (
  <div className="min-w-[120px] flex-1 border-r last:border-r-0">
    <div className={cn("sticky top-0 z-[15] flex h-14 flex-col items-center justify-center border-b bg-card", isToday(d) && "text-primary")}>
      <span className="text-[11px] font-medium uppercase tracking-wider text-muted-foreground">{fmtRo(d, "EEE")}</span>
      <span className={cn("font-display text-lg font-bold", isToday(d) && "grid h-7 w-7 place-items-center rounded-full bg-primary text-sm text-primary-foreground")}>{fmtRo(d, "d")}</span>
    </div>
    <div className={cn("relative cursor-cell transition-colors", drop.over && "bg-primary/10")} style={{ height: TOTAL_PX }} data-testid={`week-slot-${dateKey(d)}`} {...drop.props}
      onClick={(e) => onSlot(selectedStaff, `${dateKey(d)}T${slotFromClick(e)}`)}>
      <HourLines />
      {selectedStaff && <OffShade status={dayStatus(selectedStaff, d)} />}
      {layoutLanes(appts).map(({ ev, lane, lanes }) => (
        <EventBlock key={ev.id} a={ev} lane={lane} lanes={lanes} color={staffById[ev.staff_id]?.color} onClick={onEvent} showStaff={!selectedStaff} />
      ))}
    </div>
  </div>
  );
};

export const WeekView = ({ weekStart, appts, staffById, selectedStaff, onSlot, onEvent, onMove }) => {
  const days = Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));
  return (
    <div className="max-h-[calc(100vh-260px)] min-h-[420px] overflow-auto rounded-xl border bg-card" data-testid="week-view">
      <div className="flex min-w-[900px]">
        <TimeGutter />
        {days.map((d) => (
          <DayColumn key={dateKey(d)} d={d} appts={appts.filter((a) => a.start.startsWith(dateKey(d)))}
            staffById={staffById} selectedStaff={selectedStaff} onSlot={onSlot} onEvent={onEvent} onMove={onMove} />
        ))}
      </div>
    </div>
  );
};
